var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.561 43.8125C10.6034 43.8125 0.0610386 34.1688 0.0610374 22.3157C0.0610362 10.4625 10.6034 0.818845 23.561 0.818841C36.5187 0.818837 47.061 10.4625 47.061 22.3156C47.061 34.1688 36.5219 43.8125 23.561 43.8125ZM23.561 2.27625C11.4812 2.27626 1.65426 11.2656 1.65426 22.3157C1.65426 33.3657 11.4812 42.3551 23.561 42.3551C35.6408 42.3551 45.4678 33.3657 45.4678 22.3156C45.4678 11.2656 35.6408 2.27625 23.561 2.27625Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8955 14.3887L23.0611 20.6491L16.2268 14.3887L14.8955 15.6064L21.7393 21.8582L14.8955 28.11L16.2268 29.3278L23.0611 23.0674L29.8955 29.3278L31.2268 28.11L24.383 21.8582L31.2268 15.6064L29.8955 14.3887Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.4e4278b4d987d50dd7fe5be2245549ab.svg";
export { ForwardRef as ReactComponent };